function safeLogger() {
  if (process.env.REACT_APP_ENV !== "production") {
    console.log(...arguments);
  }
  return;
}

export default safeLogger;
